import React from "react";
import Frame from "../../assets/icons/Frame.svg";
import CryptoFrame from "../../assets/newIcons/cryptoFrame.svg";
import {useSelector} from "react-redux";
const NoData = ({msg}) => {
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);
  return (
    <>
      <div
        className="frame_not"
        style={{width: "100%", display: "flex", flexDirection: "column", gap: "30px", justifyContent: "center", alignItems: "center", height: "80vh"}}
      >
        <img
          style={{width: "50%"}}
          src={selectedBrand?.brand === "equity_edge" ? Frame : selectedBrand?.brand === "crypto_edge" ? CryptoFrame : Frame}
          alt=""
        />
        <div className="no_data">
          <p style={{color: "#fff", fontSize: "20px", textAlign: "center", fontWeight: "600"}}>{msg}</p>
        </div>
      </div>
    </>
  );
};

export default NoData;
